module.exports = __webpack_public_path__ + "static/CASS-4c0296264498203d24d7ff770b9ed868.png";